import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { IGha } from '../../model/gha.model';

import { API_CORE } from '../../constant/api-core.const';
import { IPresignedURL } from '../../model/presigned-url.model';
import { IPresignedGhaAttachment } from '../../model/presigned-gha-attachment.model';
import { IGhaAttachment } from '../../model/gha-attachment.model';

@Injectable({
  providedIn: 'root',
})
export class GhaService {
  async getGha(
    airlineBrandCode?: string,
    stationCode?: string,
  ): Promise<IGha[]> {
    const extraOptions: any = {
      queryParams: {},
    };
    if (airlineBrandCode) {
      extraOptions.queryParams.airline = airlineBrandCode;
    }
    if (stationCode) {
      extraOptions.queryParams.station = stationCode;
    }
    return CaiApi.get(API_CORE.name, API_CORE.URLs.Gha.Ghas, extraOptions);
  }

  async createOrUpdateGha(gha: IGha): Promise<IGha> {
    return CaiApi.post(API_CORE.name, API_CORE.URLs.Gha.Ghas, {
      body: gha,
    });
  }
  async generateUploadUrlForAttachment(
    ghaId: number,
    attachment: IGhaAttachment,
  ): Promise<IPresignedGhaAttachment> {
    const url = API_CORE.URLs.Gha.UploadAttachment.replace(
      '{ghaId}',
      ghaId.toString(),
    );
    return CaiApi.post(API_CORE.name, url, {
      body: attachment,
    });
  }
  async generateDownloadUrlForAttachment(
    ghaAttachmentId: number,
    token?: string,
  ): Promise<IPresignedURL> {
    if (!ghaAttachmentId) {
      throw new Error('GHA attachment ID is required');
    }
    const url = API_CORE.URLs.Gha.DownloadAttachment.replace(
      '{ghaAttachmentId}',
      ghaAttachmentId.toString(),
    );
    let extraOptions = {};
    if (token) {
      extraOptions = {
        queryParams: { token },
      };
    }
    try {
      return CaiApi.get(API_CORE.name, url, extraOptions);
    } catch (error) {
      console.error('Failed to download attachment:', error);
      throw error;
    }
  }
  async deleteAttachment(ghaId: number, ghaAttachmentId: number): Promise<any> {
    if (!ghaId || !ghaAttachmentId) {
      throw new Error('GHA ID and attachment ID are required');
    }
    const url = API_CORE.URLs.Gha.DeleteAttachment.replace(
      '{ghaId}',
      ghaId.toString(),
    ).replace('{ghaAttachmentId}', ghaAttachmentId.toString());
    return CaiApi.del(API_CORE.name, url, {});
  }
}
